
<p-accordionTab #deviceProfiles>
	<ng-template pTemplate="header">
		<div class="flex align-items-center">
			<span class="font-semibold">{{ 'DEVICE_PROFILES' | translate }}</span>
		</div>
	</ng-template>

	<div class="grid">
		<div class="col-12 flex align-items-center justify-content-center" *ngIf="profiles.length!==0">
			<p-listbox [options]="profiles" optionLabel="Name" readonly="true" styleClass="p-listbox-bluenohover"></p-listbox>
		</div>
		<div class="col-12" *ngIf="profiles.length===0">{{ 'NO_ENTRIES' | translate }}</div>
	</div>
</p-accordionTab>
  